(function ($) {

    $(document).ready(function () {

        if ($('.events-grid.carousel').length > 0) {
            setTimeout(function () {
                $(".events-grid.carousel").css({"opacity": "1"});
            }, 500);

            $('.events-grid.carousel .row-wrap').slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                dots: false,
                arrows: true,
                infinite: false,
                cssEase: 'linear',
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                            draggable: true
                        }
                    }
                ]
            });

            $(".events-grid").css("opacity", "1");
                $(".events-grid.carousel .col-three").css("width", "auto");
                var leftForArrow = $(".events-grid h2").outerWidth() + 16;

                $(".events-grid.carousel .slick-arrow").css("left", leftForArrow);
                $(".events-grid.carousel .slick-next").css("left", leftForArrow + 44);
        }

    });

})(jQuery);